/**
 * Returns current timestamp in ISO 8601 format
 * @returns ISO 8601 timestamp string
 */
function timestamp(): string {
  const date = new Date()
  return date.toISOString()
}

export { timestamp }
